module.exports = __webpack_public_path__ + "static/media/send-up.f4116c3e.svg";